import config from '@/config'

export default {
  props: {
    address: {
      default: '',
      type: String
    },
    wsId: {
      default: '',
      type: String
    },
    wsFormat: {
      default: 'wide',
      type: String
    },
    wsWidth: {
      default: '100%',
      type: String
    },
    wsHeight: {
      default: 525,
      type: Number
    },
    wsBackgroundColor: {
      default: '#fff',
      type: String
    }
  },
  methods: {
    init () {
      window.ws_address = this.address
      window.ws_wsid = this.wsId
      window.ws_format = this.wsFormat
      window.ws_width = this.wsWidth
      window.ws_height = this.wsHeight
      window.ws_background_color = this.wsBackgroundColor

      const script = document.createElement('script')
      script.async = true
      script.src = config.WALK_SCORE_URL
      this.$refs.wsRef.appendChild(script)
    }
  },
  mounted () {
    this.init()
  }
}
